import { Tooltip as MuiTooltip } from '@mui/material';

import type { FC } from 'react';
import type { TooltipProps } from 'shared/components/Tooltip/types';

export const Tooltip: FC<TooltipProps> = ({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
);
